import React, { Fragment, useEffect, useMemo, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { Col, Modal, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import {
  normmastercreate,
  normmasterdelete,
  normmasterdetail,
  normmasterlist,
  normmasterupdate,
  sportslist,
} from "../../../../services/master";
import Select from "react-select";
import { eventsmasterlist } from "../../../../services/superadmin";

export const NormMaster = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const [show, setShow] = useState(false);
  const [paraid, setId] = useState(0);
  const [nvalue, setNorm] = useState("");
  const [sportid, setSport] = useState("");
  const [slist, setSList] = useState([]);
  const [status, setStatus] = useState("1");
  const [errorMsg, setErrorMsg] = useState("");
  const [asstype, setAssType] = useState("");
  const [tlist, setTList] = useState([]);

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);

  const columnDefs = [
    {
      headerName: "Norm",
      field: "norm_value",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Sports",
      field: "sports_category",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Status",
      field: "is_active",
      resizable: true,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <label className="custom-switch mb-0">
              <input
                type="checkbox"
                name="custom-switch-checkbox"
                className="custom-switch-input"
                checked={params.value === 1 ? true : false}
                onChange={() => deletedistrict(params)}
              />

              <span className="custom-switch-indicator"></span>
            </label>
          </div>
        );
      },
    },
    {
      headerName: "Actions",
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => virenorm(params.value)}
              title="Edit Parameter"
              className="btn-sm btn-secondary"
            >
              <i className="fa fa-edit fa-lg"></i>
            </a>
          </div>
        );
      },
    },
  ];

  function virenorm(aid) {
    setShow(true);
    normmasterdetail(aid).then((response) => {
      if (response.status === true) {
        setId(response.data.normDetails.id);
        sportslist().then((res) => {
          if (res.status === true) {
            if (res.data.length !== 0) {
              let arr = [];
              for (let i = 0; i < res.data.length; i++) {
                if (
                  response.data.normDetails.sports_id ==
                  res.data[i].sports_cat_uid
                ) {
                  arr.push({
                    label: res.data[i].sports_category,
                    value: res.data[i].sports_cat_uid,
                  });
                }
              }
              setSport(arr[0]);
            }
          }
        });

        eventsmasterlist().then((res) => {
          if (res.status === true) {
            if (res.data.length !== 0) {
              let arr = [];
              for (let i = 0; i < res.data.length; i++) {
                arr.push({
                  label: res.data[i].event_name,
                  value: res.data[i].event_uid,
                });
              }

              setTList(arr);

              const sdata = arr.find(
                (item) => item.value == response.data.normDetails.event_id
              );
              setAssType(sdata);
            }
          }
        });
        setNorm(response.data.normDetails.norm_value);
        setSName(response.data.normDetails.sports_category);
        setStatus(response.data.normDetails.status + "");
        dotracking(
          "edit button in norm for " +
            response.data.norm_value +
            " (" +
            aid +
            ") $$ " +
            trackobj.normheading
        );
      }
    });
  }

  function handleshow() {
    setId(0);
    setNorm("");
    setSport("");
    setTList([]);
    setAssType("");
    setStatus("1");
    setErrorMsg("");
    setShow(true);
  }
  function handleclose() {
    setShow(false);
    setId(0);
    setNorm("");
    setAssType("");
    setTList([]);
    setSport("");
    setStatus("1");
    setErrorMsg("");
  }

  function deletedistrict(list) {
    if (list.value === 1) {
      Swal.fire({
        text: "Are you sure want to Inactive?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Inactive",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("norm_id", list.data.id);
          temp.append("active_inactive", 0);
          dotracking(
            "status icon in norm list from Inactive to Active for " +
              list.data.norm_value +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.normheading
          );
          normmasterdelete(temp).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Active?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Active",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const temp = new FormData();
          temp.append("norm_id", list.data.id);
          temp.append("active_inactive", 1);
          dotracking(
            "status icon in norm list from Inactive to Active for " +
              list.data.norm_value +
              " (" +
              list.data.id +
              ") $$ " +
              trackobj.normheading
          );
          normmasterdelete(temp).then((response) => {
            if (response.status === true) {
              listall();
              toast.success(response.message);
            }
          });
        }
      });
    }
  }
  useEffect(() => {
    listall();
    sportslist().then((response) => {
      if (response.status === true) {
        if (response.data.length !== 0) {
          let arr = [];
          for (let i = 0; i < response.data.length; i++) {
            arr.push({
              label: response.data[i].sports_category,
              value: response.data[i].sports_cat_uid,
            });
          }
          setSList(arr);
        }
      }
    });
  }, []);

  function listall() {
    setFilterProduct([]);
    normmasterlist().then((response) => {
      if (response.status === true) {
        setFilterProduct(response.data.mormList);
      }
    });
  }

  //   function Selectstatus(e) {
  //     setStatus(e.target.value);
  //   }

  function submitdistrict(e) {
    e.preventDefault();
    setErrorMsg("");

    if (sportid !== "") {
      if (nvalue !== "") {
        if (paraid === 0) {
          if (sname.toUpperCase() === "ATHLETICS") {

            const regex = /^\d{2}:\d{2}\.\d{2}$/;
            if (!regex.test(nvalue)) {
                setErrorMsg("Please Enter Norm Value in format: 00:00.00");
                return;
            }
            
            if (asstype == "") {
              setErrorMsg("Please Select Event");
              return;
            }
          }
          const temp = new FormData();
          temp.append("sports_id", sportid.value);
          temp.append("norm_value", nvalue);
          if (asstype !== "") {
            temp.append("event_id", asstype.value);
          } else {
            temp.append("event_id", 0);
          }
          temp.append("admin_id", localStorage.getItem("UID"));

          dotracking(
            "add button for norm in norm list for " +
              nvalue +
              " (" +
              paraid +
              ") $$ " +
              trackobj.normheading
          );
          normmastercreate(temp).then((response) => {
            if (response.status === true) {
              handleclose();
              listall();
              toast.success(response.message);
            }
          });
        } else if (paraid !== 0) {
            if (sname.toUpperCase() === "ATHLETICS") {
                const regex = /^\d{2}:\d{2}\.\d{2}$/;
                if (!regex.test(nvalue)) {
                    setErrorMsg("Please Enter Norm Value in format: 00:00.00");
                    return;
                }
              }
          const temp = new FormData();
          temp.append("norm_id", paraid);
          //   temp.append("sports_id", sportid);
          temp.append("norm_value", nvalue);
          //   if (asstype !== "") {
          //     temp.append("assessment_type_id", asstype.value);
          //   } else {
          //     temp.append("assessment_type_id", 0);
          //   }
          temp.append("admin_id", localStorage.getItem("UID"));
          // temp.append("isactive", status)
          dotracking(
            "update button for norm in norm list for " +
              nvalue +
              " (" +
              paraid +
              ") $$ " +
              trackobj.normheading
          );
          normmasterupdate(temp).then((response) => {
            if (response.status === true) {
              handleclose();
              listall();
              toast.success(response.message);
            }
          });
        }
      } else {
        setErrorMsg("Please Enter Norm Value");
      }
    } else {
      setErrorMsg("Please Select Sports");
    }
  }

  const [sname, setSName] = useState("");

  function handleSport(e) {
    setTList([]);
    if (e !== null) {
      setSport(e);
      setSName(e.label);
      const sp = e.label;
      if (sp.toUpperCase() === "ATHLETICS") {
        listtype(e);
      }
    } else {
      setSport("");
      setSName("");
    }
  }

  function handleType(e) {
    if (e !== null) {
      setAssType(e);
    } else {
      setAssType("");
    }
  }

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setNorm(e.target.value);
    }
  };

  function listtype() {
    setTList([]);
    eventsmasterlist().then((response) => {
      if (response.status === true) {
        let arr = [];
        if (response.data.length !== 0) {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].is_active === 1) {
              arr.push({
                value: response.data[i].event_uid,
                label: response.data[i].event_name,
              });
            }
          }
        }
        setTList(arr);
      }
    });
  }

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">NORM Lists</h4>
        </div>
        <ol className="breadcrumb">
          {localStorage.getItem("Subrole") === "1" && (
            <li className="breadcrumb-item">
              <a>Setup</a>
            </li>
          )}
          {localStorage.getItem("Subrole") !== "1" && (
            <li className="breadcrumb-item">
              <a>Master</a>
            </li>
          )}
          <li className="breadcrumb-item active" aria-current="page">
            NORM Lists
          </li>
        </ol>
      </div>

      <div className="row">
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <div className="text-right">
                <a className="btn btn-success" onClick={handleshow}>
                  <i className="fa fa-plus"></i> Add NORM
                </a>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={columnDefs}
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={sorting}
                  suppressExcelExport={true}
                  suppressDragLeaveHidesColumns={true}
                  domLayout="autoWidth"
                  onGridReady={(params) => {
                    params.api.sizeColumnsToFit();
                  }}
                />
              </div>

              <Modal show={show} size="lg" onHide={handleclose}>
                <Modal.Header>
                  {paraid !== 0 && <h4> NORM Details</h4>}
                  {paraid === 0 && <h4> Add NORM</h4>}
                </Modal.Header>
                <Modal.Body>
                  <Row className="row-sm mx-0">
                    {paraid === 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Sports"
                            value={sportid}
                            options={slist}
                            onChange={handleSport}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </Col>
                    )}
                    {paraid !== 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Sports <span className="errortext"> *</span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Sports"
                            value={sportid}
                            options={slist}
                            onChange={handleSport}
                            isSearchable={true}
                            isClearable
                            hidden
                            isDisabled
                          />
                        </div>
                      </Col>
                    )}
                    {sname.toUpperCase() === "ATHLETICS" && paraid !== 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Event <span className="errortext"></span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Event"
                            value={asstype}
                            options={tlist}
                            onChange={handleType}
                            isSearchable={true}
                            isClearable
                            hidden
                            isDisabled
                          />
                        </div>
                      </Col>
                    )}
                    {sname.toUpperCase() === "ATHLETICS"&& paraid == 0 && (
                      <Col lg={12} md={12}>
                        <div className="form-group">
                          <label className="mb-2">
                            Event <span className="errortext"></span>
                          </label>
                          <Select
                            className="dropdown"
                            placeholder="Select Event"
                            value={asstype}
                            options={tlist}
                            onChange={handleType}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </Col>
                    )}


                    <Col lg={12} md={12}>
                      <div className="form-group">
                        <label className="mb-2">
                          Norm Value{" "}
                          <span className="errortext">
                            {" "}
                            *
                            {sname.toUpperCase() === "ATHLETICS"
                              ? "(Format like 00:00.00)"
                              : ""}
                          </span>
                        </label>
                        <input
                          type="text"
                          placeholder="Norm Value"
                          className="form-control"
                          value={nvalue}
                          onChange={(e) =>
                            sname.toUpperCase() === "ATHLETICS"
                              ? setNorm(e.target.value)
                              : handleChange(e)
                          }
                        />
                      </div>
                    </Col>

                    {/* <Col lg={12} md={12}>
                                            <div className="form-group">
                                                <label className="mb-2">
                                                    Status <span className="errortext"> *</span>
                                                </label>

                                                <div className="row" onChange={Selectstatus}>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="1"
                                                                checked={status === "1"}
                                                            />
                                                            {" "} Active
                                                        </label>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label className="custom-control custom-radio custom-control-md">
                                                            <input
                                                                type="radio"
                                                                className="reg-chk"
                                                                id="active"
                                                                value="0"
                                                                checked={status === "0"}
                                                            />
                                                            {" "}Inactive
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                        </Col> */}
                    {errorMsg !== "" && (
                      <span className="errortext">{errorMsg}</span>
                    )}
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <a className="btn btn-danger" onClick={handleclose}>
                    Close
                  </a>
                  {paraid !== 0 && (
                    <a className="btn btn-success" onClick={submitdistrict}>
                      Update
                    </a>
                  )}
                  {paraid === 0 && (
                    <a className="btn btn-success" onClick={submitdistrict}>
                      Add
                    </a>
                  )}
                </Modal.Footer>
              </Modal>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
